import { __rest as e } from "tslib";
import * as o from "react";
import a from "classnames";
import { classNameModifier as t, classNameModifierByFlag as n } from "../shared/utils.js";
import { ComponentClassNames as r } from "../shared/constants.js";
import { View as s } from "../View/View.js";
var i = o.forwardRef(function (i, l) {
  var u = i.autoComplete,
    d = i.checked,
    p = i.className,
    c = i.defaultChecked,
    m = i.defaultValue,
    h = i.id,
    C = i.isDisabled,
    f = i.isReadOnly,
    y = i.isRequired,
    v = i.size,
    _i$type = i.type,
    I = _i$type === void 0 ? "text" : _i$type,
    _i$hasError = i.hasError,
    k = _i$hasError === void 0 ? !1 : _i$hasError,
    b = i.value,
    R = i.variation,
    V = i.onBlur,
    g = i.onChange,
    j = i.onCopy,
    F = i.onCut,
    N = i.onFocus,
    O = i.onInput,
    q = i.onPaste,
    w = i.onSelect,
    z = i.onWheel,
    B = e(i, ["autoComplete", "checked", "className", "defaultChecked", "defaultValue", "id", "isDisabled", "isReadOnly", "isRequired", "size", "type", "hasError", "value", "variation", "onBlur", "onChange", "onCopy", "onCut", "onFocus", "onInput", "onPaste", "onSelect", "onWheel"]);
  var D = a(r.Input, r.FieldGroupControl, t(r.Input, R), n(r.Input, "error", k), t(r.Input, v), p);
  return o.createElement(s, Object.assign({
    "aria-invalid": k,
    as: "input",
    autoComplete: u,
    checked: d,
    className: D,
    "data-size": v,
    "data-variation": R,
    defaultChecked: c,
    defaultValue: m,
    isDisabled: C,
    id: h,
    onBlur: V,
    onChange: g,
    onCopy: j,
    onCut: F,
    onFocus: N,
    onInput: O,
    onPaste: q,
    onSelect: w,
    onWheel: z,
    readOnly: f,
    ref: l,
    required: y,
    type: I,
    value: b
  }, B));
});
i.displayName = "Input";
export { i as Input };